module.exports = __webpack_public_path__ + "img/homelisticon2.3283cee7.png";